import React from 'react';

const MarqueeSection = () => {
  return (
    <>
      <div className="w-full bg-[#0f172a] py-6 lg:py-8 overflow-hidden">
        <div className="flex w-max">
          <div className="flex animate-scroll">
            {[...Array(10)].map((_, i) => (
              <div key={i} className="flex items-center pl-4 lg:pl-6 pr-8 lg:pr-12">
                <svg className="w-6 h-6 lg:w-10 lg:h-10 mr-8 lg:mr-14" viewBox="0 0 40 40" fill="none">
                  <path d="M20 0L21.8 18.2L40 20L21.8 21.8L20 40L18.2 21.8L0 20L18.2 18.2L20 0Z" fill="white" fillOpacity="0.3" />
                </svg>
                <span style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 600, letterSpacing: '0.12em' }}
                  className="text-4xl lg:text-6xl xl:text-7xl text-white whitespace-nowrap uppercase">
                  VIBRANTVIVA
                </span>
              </div>
            ))}
          </div>
          {/* <div className="flex animate-scroll">
            {[...Array(10)].map((_, i) => (
              <div key={`dup-${i}`} className="flex items-center px-8 lg:px-12">
                <svg className="w-6 h-6 lg:w-10 lg:h-10 mr-4 lg:mr-8" viewBox="0 0 40 40" fill="none">
                  <path d="M20 0L21.8 18.2L40 20L21.8 21.8L20 40L18.2 21.8L0 20L18.2 18.2L20 0Z" fill="white" fillOpacity="0.3" />
                </svg>
                <span style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 600, letterSpacing: '0.12em' }}
                  className="text-4xl lg:text-6xl xl:text-7xl text-white whitespace-nowrap uppercase">
                  VIBRANTVIVA
                </span>
              </div>
            ))}
          </div> */}
        </div>
      </div>
      <style dangerouslySetInnerHTML={{ __html: `
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;1,400;1,500&family=Outfit:wght@300;400;500;600;700&display=swap');

        .marquee-root *, .marquee-root *::before, .marquee-root *::after {
          font-family: 'Outfit', sans-serif;
          box-sizing: border-box;
        }

        @keyframes scroll-left {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-scroll {
          animation: scroll-left 25s linear infinite;
        }
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}} />
    </>
  );
};

export default MarqueeSection;